import Controller from "./searchableMultiSelect.controller";
import template from "./searchableMultiSelect.html";

const searchableMultiSelect = {
  template,
  controller: Controller,
  bindings: {
    items: "=",
    itemTitle: "@",
    isDisabled: "<",
    noItemsMessage: "@",
    removeOld: "<",
    onAutoCompleteSearch: "<",
    name: "@",
  },
};

export default searchableMultiSelect;



// WEBPACK FOOTER //
// ./src/components/searchableMultiSelect/searchableMultiSelect.component.js